import { render, staticRenderFns } from "./EditModelOfflineFormPage.vue?vue&type=template&id=72669086&scoped=true"
import script from "./EditModelOfflineFormPage.vue?vue&type=script&lang=ts"
export * from "./EditModelOfflineFormPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72669086",
  null
  
)

export default component.exports